import React, { ReactElement, memo } from "react";
import PageLayout from "../../PageLayout";
import { Grid } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { CardPromptType } from "../../../store/cardPrompt/types";
import { save } from "../../../store/cardPrompt/cardPromptSlice";
import { ApplicationState } from "../../../store";
import { Formik } from "formik";
import { useHistory } from "react-router-dom";
import schema from "./CardPromptEdit.schema";
import pageStyles from "../../pageStyles";
import FormSubmitButtons from "../../../common/buttons/FormSubmitButtons";
import SectionWrapper from "../../../common/pageSections/SectionWrapper";
import TextInput from "../../../common/formElements/TextInput";
import CardPromptBins from "./CardPromptBins";
import { useToastMessage } from "../../../effects/useToastMessage";
import { toast } from "react-toastify";

const CardPromptEdit = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const classes = pageStyles();
  const selected = useSelector<ApplicationState>(
    (store) => store.cardPrompt.selected
  ) as CardPromptType;

  const title = selected.id ? "Edit Card Prompt" : "Add Card Prompt";

  const onSubmit = (values: CardPromptType) => {
    const result = dispatch(
      save({
        id: values.id,
        payload: values.attributes,
      })
    );

    // @ts-ignore
    result.then(() => {
      if (selected.id) {
        toast.success("Saved successfully!", {
          closeOnClick: true,
        });
      } else {
        history.push("/cardPrompt");
      }
    });
  };

  const onCancel = () => {
    history.push("/cardPrompt");
  };

  return (
    <PageLayout heading={title}>
      <Formik
        initialValues={selected}
        validationSchema={schema}
        onSubmit={onSubmit}
        onReset={onCancel}
      >
        {(formikProps) => {
          const { isSubmitting, errors } = formikProps;
          // Show toast errors
          useToastMessage(isSubmitting, errors);
          return (
            <form
              onSubmit={formikProps.handleSubmit}
              onReset={formikProps.handleReset}
              className={classes.formWrapper as string}
            >
              <SectionWrapper title="Card Prompt">
                <SectionWrapper isChild title="Card Prompt Info">
                  <Grid item xs={12} md={4}>
                    <TextInput fieldname="attributes.Name" label="Name" />
                  </Grid>
                </SectionWrapper>

                <SectionWrapper isChild title="Card Bins">
                  <CardPromptBins
                    cardPromptData={selected}
                    formikProps={formikProps}
                  />
                </SectionWrapper>
              </SectionWrapper>

              <FormSubmitButtons />
            </form>
          );
        }}
      </Formik>
    </PageLayout>
  );
};

export default memo(CardPromptEdit);
